import Address from "components/Parts/Address";
import CustomerName from "components/Parts/CustomerName";
import DispositionQuestions from "components/Parts/DispositionQuestions";
import DispositionSignatures from "components/Parts/DispositionSignatures";
import DispositionSignatures_v2 from "components/Parts/DispositionSignatures_v2";
import HardwareList from "components/Parts/HardwareList";
import LocationsList from "components/Parts/LocationsList";
import ModulesList from "components/Parts/ModulesList";
import ServicesList from "components/Parts/ServicesList";
import TransactionLegalEntity from "components/Parts/TransactionLegalEntity";
import TransactionCustomer from "components/Parts/TransactionCustomer";
import TransactionDealer from "components/Parts/TransactionDealer";
import TransactionDetails from "components/Parts/TransactionDetails";
import TransactionEvent from "components/Parts/TransactionEvent";
import TransactionExport from "components/Parts/TransactionExport";
import TransactionInternal from "components/Parts/TransactionInternal";
import TransactionImporter from "components/Parts/TransactionImporter";
import UpgradesList from "components/Parts/UpgradesList";

import SelectLocation from "components/Parts/SelectLocation";
import SelectBoundBook from "components/Parts/SelectBoundBook";
import DispositionQuestions_August2023 from "./DispositionQuestions_August2023";

const Parts = {
	Address: Address,
	CustomerName: CustomerName,
	DispositionQuestions: DispositionQuestions,
	DispositionQuestions_August2023: DispositionQuestions_August2023,
	DispositionSignatures: DispositionSignatures,
	DispositionSignatures_v2: DispositionSignatures_v2,
	HardwareList: HardwareList,
	LocationsList: LocationsList,
	ModulesList: ModulesList,
	ServicesList: ServicesList,
	TransactionLegalEntity: TransactionLegalEntity,
	TransactionCustomer: TransactionCustomer,
	TransactionDealer: TransactionDealer,
	TransactionImporter: TransactionImporter,
	TransactionDetails: TransactionDetails,
	TransactionEvent: TransactionEvent,
	TransactionExport: TransactionExport,
	TransactionInternal: TransactionInternal,
	UpgradesList: UpgradesList,
	SelectLocation: SelectLocation,
	SelectBoundBook: SelectBoundBook,
};

export default Parts;
